<script setup>
const config = useRuntimeConfig()
const props = defineProps(
    {
        data: {
            type: Object,
            required: true
        }
    }
)
</script>

<template>
    <NuxtLink :to="`/${props.data.locale}/supplier/${props.data.slug}`"
        class="p-4 md:p-7 h-32 bg-gray-100 rounded-lg dark:bg-slate-800 flex justify-center items-center ">
        <img v-if="props.data.logo" :src="config.public.apiBase + '/public/uploads/' + props.data.logo" alt="art cover"
            loading="lazy" width="1000" height="667"
            class="py-3 lg:py-5  h-auto w-full mx-auto max-h-28 dark:grayscale dark:invert">

        <div v-else class="font-bold text-center dark:text-slate-200 text-slate-800 text-lg">
            {{ props.data.name }}
        </div>
    </NuxtLink>
</template>